module.exports = __webpack_public_path__ + "static/media/practise.a6420486.jpg";